import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { SzIconComponent } from '../../display/sz-icon';
import { SzNumpadKey } from './sz-numpad-key.type';

@Component({
  selector: 'sz-numpad-grid',
  templateUrl: './sz-numpad-grid.component.html',
  styleUrls: ['./sz-numpad-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzIconComponent]
})
export class SzNumpadGridComponent {
  readonly keys: InputSignal<ReadonlyArray<SzNumpadKey>> = input.required<ReadonlyArray<SzNumpadKey>>();
  readonly disabled: InputSignal<boolean> = input<boolean>(false);

  @Output() readonly press: EventEmitter<string> = new EventEmitter<string>();

  onPress(value: string): void {
    if (this.disabled()) {
      return;
    }
    this.press.emit(value);
  }
}
